<template>
    <div class="discussion-navigation">
        <div v-if="error" ref="status" class="discussion-navigation__status" role="status" tabindex="-1">
            {{ error }} <button type="button" @click="load(reference)">Повторить</button>
        </div>
    </div>
</template>
<script>
import {readMessage, discussionEvents, discussionContextMixin, contextKey} from '@/utils/discussions';
const {messageKey} = require('../../../../shared/discussionText');
export default {
    name: 'DiscussionTarget', mixins: [discussionContextMixin],
    data: () => ({reference: null, error: '', version: 0}),
    mounted() { this.jumpListener = (ref, quote) => this.load(ref, quote); discussionEvents.$on('jump', this.jumpListener); this.$nextTick(this.fromRoute); },
    beforeDestroy() { this.version++; this.stopWaiting(); this.clearHighlight(); discussionEvents.$off('jump', this.jumpListener); },
    watch: {'$route.query.discussion'() { this.fromRoute(); }, currentContext: {deep: true, handler() { this.version++; this.stopWaiting(); this.error = ''; this.fromRoute(); }}},
    methods: {
        fromRoute() { try { if (this.$route.query.discussion) this.load(JSON.parse(this.$route.query.discussion)); } catch (e) { /* Invalid links never become selectors. */ } },
        stopWaiting() { if (this.finishWaiting) this.finishWaiting(null); },
        clearHighlight() { clearTimeout(this.highlightTimer); if (this.highlighted) this.highlighted.classList.remove('discussion-highlight'); this.highlighted = null; discussionEvents.$emit('highlight-quote', null); },
        findTarget(ref) {
            const key = messageKey(ref), source = messageKey(ref, true);
            const nodes = Array.from(document.querySelectorAll('[data-discussion-key], [data-discussion-source]')).filter(el => el.getClientRects().length);
            return nodes.find(el => el.dataset.discussionKey === key) || nodes.find(el => el.dataset.discussionSource === source);
        },
        waitForTarget(ref) {
            const found = this.findTarget(ref); if (found) return Promise.resolve(found);
            return new Promise(resolve => {
                const observer = new MutationObserver(() => { const target = this.findTarget(ref); if (target) finish(target); });
                const timer = setTimeout(() => finish(null), 4000);
                const finish = target => { observer.disconnect(); clearTimeout(timer); this.finishWaiting = null; resolve(target); };
                this.finishWaiting = finish;
                observer.observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['data-discussion-key', 'data-discussion-source', 'class', 'style']});
            });
        },
        async load(ref, quote) {
            if (!ref || contextKey(this.currentContext) !== contextKey({type: ref.context_type, id: ref.context_id})) return;
            this.stopWaiting(); this.clearHighlight(); this.reference = ref; const version = ++this.version; this.error = '';
            discussionEvents.$emit('reveal-message', ref);
            await this.$nextTick();
            const target = await this.waitForTarget(ref);
            if (version !== this.version || this._isDestroyed) return;
            if (target) {
                this.highlighted = target;
                target.scrollIntoView({block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
                target.focus({preventScroll: true});
                // Flush the removed class so a second click restarts the same animation.
                void target.offsetWidth;
                target.classList.add('discussion-highlight');
                discussionEvents.$emit('highlight-quote', ref, quote);
                this.highlightTimer = setTimeout(this.clearHighlight, 3000);
                return;
            }
            try {
                const message = await readMessage(ref);
                if (version !== this.version || this._isDestroyed) return;
                this.error = message.deleted || message.unavailable ? 'Исходное сообщение удалено или недоступно.' : 'Исходное сообщение сейчас не показано в ленте. Обновите карточку.';
            } catch (e) { if (version === this.version) this.error = 'Не удалось найти исходное сообщение. Повторите попытку.'; }
            this.$nextTick(() => { if (this.$refs.status) { this.$refs.status.scrollIntoView({block: 'center'}); this.$refs.status.focus(); } });
        }
    }
};
</script>
<style>
.discussion-navigation__status { padding: 8px 10px; margin: 8px 0; color: #52687b; background: #f2f7fa; border-radius: 8px; }
.discussion-highlight { outline: 2px solid #4384b3; outline-offset: 4px; border-radius: 8px; scroll-margin-block: 90px; animation: discussion-source-pulse 850ms ease-in-out 250ms 3 both; }
@keyframes discussion-source-pulse {
    0%, 100% { background-color: #f0f7fc; outline-color: #a7cce6; box-shadow: 0 0 0 4px #e7f3fc; }
    50% { background-color: #c9e7fc; outline-color: #2685c6; box-shadow: 0 0 0 6px #d5ebfa; }
}
@media (prefers-reduced-motion: reduce) { .discussion-highlight { animation: none; background-color: #d8edfc; } }
</style>
